import _ from "lodash";
import store from "services/redux/store";
import { setData } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchParkingStatuses from 'utils/fetch/FetchParkingStatuses'

export default class FetchCachedParkingStatuses {
	
	static logName = 'FetchCachedParkingStatuses';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'parking_statuses',
				tables: [ 'parking_statuses' ],
				onExpire: this.reload,
				updated_at_max_age: ( 1 * 60 ) // 1 minute
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchParkingStatuses.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( values ) => {
						// Save to object
						this.process( values );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, values, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( values );
						}
					}
				})
			);
		}
		)
	}

	static process = ( values ) => {
		this.values = values;
		
		store.dispatch( setData( dataConstants.PARKING_STATUSES, this.values ) );
	}
}
